import TopPosts from './top-posts';

export default TopPosts;